export default __webpack_public_path__ + "static/media/certified-labs.252894da.svg";